import Vue from 'vue'
import VueRouter from 'vue-router'

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Admin',
    component: () => import('../views/index.vue'),
    redirect: () => {
      const user = JSON.parse(localStorage.getItem('honey-user') || '{}');
      if (user.role === '管理员') {
        return '/home';
      }
      return '/user-home';
    },
    children: [
      { path: '403', name: 'Auth', meta: { name: '无权限' }, component: () => import('../views/admin/Auth') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/admin/Home') },
      { path: 'user-home', name: 'UserHome', meta: { name: '我的首页' }, component: () => import('../views/admin/UserHome') },
      { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/admin/User') },
      { path: 'customer', name: 'Customer', meta: { name: '客户管理' }, component: () => import('../views/admin/Customer') },
      { path: 'customer-assign', name: 'CustomerAssign', meta: { name: '客户分配' }, component: () => import('../views/admin/CustomerAssign') },
      { path: 'customer-follow', name: 'CustomerFollow', meta: { name: '客户跟进' }, component: () => import('../views/admin/CustomerFollow') },
      { path: 'customer-recycle', name: 'CustomerRecycle', meta: { name: '回收站' }, component: () => import('../views/admin/CustomerRecycle') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/admin/Person') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/admin/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '系统公告' }, component: () => import('../views/admin/Notice') },
      { path: 'dict', name: 'Dict', meta: { name: '字典管理' }, component: () => import('../views/admin/Dict') },
      { path: 'login-log', name: 'LoginLog', meta: { name: '登录日志' }, component: () => import('../views/admin/LoginLog') },
      { path: 'operation-log', name: 'OperationLog', meta: { name: '操作日志' }, component: () => import('../views/admin/OperationLog') },
      { path: 'online-user', name: 'OnlineUser', meta: { name: '在线用户' }, component: () => import('../views/admin/OnlineUser') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: '404', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // to 是到达的路由信息
  // from 是开源的路由信息
  // next 是帮助我们跳转路由的函数
  
  let user = JSON.parse(localStorage.getItem('honey-user') || '{}')
  
  // 不需要登录验证的页面
  const publicPages = ['/login', '/register']
  
  // 如果访问的是公开页面，直接放行
  if (publicPages.includes(to.path)) {
    next()
    return
  }
  
  // 检查用户是否已登录（有token和用户信息）
  if (!user.token || !user.id || !user.role) {
    // 未登录，跳转到登录页面
    next('/login')
    return
  }
  
  // 定义各角色的权限路径
  const rolePermissions = {
    '管理员': ['/home', '/user', '/customer', '/customer-assign', '/customer-follow', '/customer-recycle', '/notice', '/dict', '/login-log', '/operation-log', '/online-user', '/person', '/password'],
    '资源部': ['/user-home', '/customer', '/person', '/password'],
    '电销部': ['/user-home', '/customer', '/customer-follow', '/person', '/password'],
    '后期服务': ['/user-home', '/customer', '/customer-follow', '/person', '/password']
  }
  
  // 获取当前用户角色的允许路径
  const allowedPaths = rolePermissions[user.role] || []
  
  // 检查用户是否有权限访问该路径
  if (!allowedPaths.includes(to.path)) {
    // 如果用户没有权限访问该路径，跳转到403页面
    next('/403')
  } else {
    next()
  }
})

export default router
